import React, { useContext } from "react";
import { Transition } from "@headlessui/react";

import StoreLocatorContext from "context/StoreLocatorContext";
import { Store } from "custom-types/StoreLocator";
import useSpotlight from "hooks/dispensaries/useSpotlight";
import useWindowSize from "hooks/useWindowSize";

import MobileStoreCard from "./MobileStoreCard";
import Spotlight from "./Spotlight";

const MapOverlays: React.FC<{
  spotlightStores: Store[];
}> = ({ spotlightStores }) => {
  const { isMobile } = useWindowSize();

  const { selectedStore } = useContext(StoreLocatorContext);
  const { spotlightDismissed, onSpotlightDismissed, spotlightStore } =
    useSpotlight(spotlightStores);

  return (
    <>
      <div className="absolute bottom-0 right-0 left-0 md:w-fit">
        <Transition
          show={
            isMobile
              ? !spotlightDismissed && !selectedStore
              : !spotlightDismissed
          }
          enterFrom="translate-y-[100%] opacity-0"
          enterTo="translate-y-0 opacity-1"
          leaveFrom="translate-y-0 opacity-1"
          leaveTo="translate-y-[100%] opacity-0"
        >
          <div className="transition md:m-lg">
            {spotlightStore && (
              <Spotlight
                store={spotlightStore}
                onDismissed={onSpotlightDismissed}
              />
            )}
          </div>
        </Transition>
      </div>
      <div className="absolute bottom-0 right-0 left-0 md:hidden">
        <Transition
          show={!!selectedStore}
          enterFrom="translate-y-[100%] opacity-0"
          enterTo="translate-y-0 opacity-1"
          leaveFrom="translate-y-0 opacity-1"
          leaveTo="translate-y-[100%] opacity-0"
        >
          <div className="transition">
            {isMobile && selectedStore && (
              <MobileStoreCard store={selectedStore} />
            )}
          </div>
        </Transition>
      </div>
    </>
  );
};

export default MapOverlays;
